<template lang="pug">
.content-wrapper
  StepsCard()
    template(#steps)
      router-link(:to="searchPatientLink" v-slot="{ isActive }" custom)
        li(:class="[isActive && 'router-link-exact-active']")
          span Search Patient
          base-icon(name="arrow-steps")

      router-link(:to="selectPatientLink" v-slot="{ isActive }" custom)
        li(:class="[isActive && 'router-link-exact-active']")
          span Select Patient
          base-icon(name="arrow-steps")
      
      router-link(:to="selectPatientLink"  custom)
        li()
          span Schedule Patient


    template(#content)
      router-view()
</template>

<script>
import { defineComponent, computed } from "vue";
import { useRoute } from "vue-router";
import StepsCard from "@/components/StepsCard.vue";

export default defineComponent({
  components: {
    StepsCard,
  },
  setup() {
    const route = useRoute();

    const baseParams = computed(() => ({
      idCommunity: route.params.idCommunity,
    }));

    const searchPatientLink = computed(() => ({
      name: "cco-patient-navigation.scheduling.search-patient",
      params: baseParams.value,
    }));

    const selectPatientLink = computed(() => ({
      name: "cco-patient-navigation.scheduling.select-patient",
      params: baseParams.value,
    }));

    return {
      searchPatientLink,
      selectPatientLink,
    };
  },
});
</script>

<style scoped lang="scss">
.content-wrapper {
  position: relative;
  padding-bottom: 40px;
}
</style>
